<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='machine-grid'>
      <dx-data-grid ref='refPressDieGrid'
        :data-source='pressDieInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @editor-preparing='onEditorPreparing'
        @init-new-row='onInitNewRow'
        @toolbar-preparing='onToolbarPreparingRegPressDieImage'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="금형관리정보"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="(userInfo.permission & crudAllow) > 0"
          :allow-updating="(userInfo.permission & crudAllow) > 0"
          :allow-adding="(userInfo.permission & crudAllow) > 0"
          :use-icons="true"
          mode='popup'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="500"
            title="금형정보등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
              <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              >
                <DxItem data-field="생산품번"/>
                <DxItem data-field="공정순서"/>
                <DxItem data-field="공정명"/>
                <DxItem data-field="사급여부"/>
                <DxItem data-field="구입가격"/>
                <DxItem data-field="입고일자"/>
                <DxItem data-field="제작처"/>
                <DxItem data-field="제품생산처"/>
                <DxItem data-field="고객사"/>
                <DxItem data-field="반납일자"/>
                <DxItem
                  data-field="파일경로"
                  :visible="false"
                />
              </DxItem>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="보수이력"
                >
                  <DxItem :col-span="2"
              :editor-options="{ height: 140 }"
              data-field="보수내역"
              editor-type="dxTextArea"
              />
              </DxItem>
            </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="70"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn
          :allowEditing='true'
          caption="생산품번"
          data-field="생산품번"
          :visible='true'
          :fixed="true"
          edit-cell-template="productionGridTemplate"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="true"
          caption="공정순서"
          data-field="공정순서"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          :fixed="true"
          caption="공정명"
          data-field="공정명"
        >
        <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사급여부"
          data-field="사급여부"
          :visible='true'
        >
          <DxLookup
            :data-source="pressDieTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="구입가격"
          data-field="구입가격"
          :visible='true'
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="입고일자"
          data-field="입고일자"
          dataType= 'date'
          format='yyyy-MM-dd'
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="제작처"
          data-field="제작처"
          :visible='true'
        >
         <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="제품생산처"
          data-field="제품생산처"
          :visible='true'
          edit-cell-template="proCompanyGridTemplate"
        >
          <DxLookup
            :data-source="partnerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
         <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="고객사"
          data-field="고객사"
          :visible='true'
          edit-cell-template="companyGridTemplate"
        >
          <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="반납일자"
          data-field="반납일자"
          dataType= 'date'
          format='yyyy-MM-dd'
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          data-field="파일경로"
          caption="제품사진"
          :visible="true"
        >
        </DxColumn>
        <DxColumn
          data-field="보수내역"
          caption="보수내역"
          :visible="true"
          :min-width="200"
         >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="생산품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #productionGridTemplate="{ data: cellInfo }">
          <ProductionGridComponent
            option="품번"
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @selected-pcode='setProductionCode'
            :productionInfo='productionList'
            :isEdit='isIdEdit'
          />
        </template>
        <template #companyGridTemplate="{ data: cellInfo }" >
          <CompanyGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @selected-company='setCompnayCode'
            :companyInfo='companyInfoList발주사'
          />
        </template>
        <template #proCompanyGridTemplate="{ data: cellInfo }" >
          <CompanyGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @selected-company='setProCompnayCode'
            :companyInfo='companyInfoList협력사'
          />
        </template>
      </dx-data-grid>
      <div>
        <input id='product-photo-input' class="inputFile" type="file" name="image" accept="image/*" @change="onFileChange" style='display:none'/>
        <input id="die-drawing-input" class="inputFile" type="file" name="file" @change="onFileChange" accept="" style='display: none;'>
      </div>
    <DxPopupGen
      :visible.sync="popupPressDieFileList"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="450"
      :height="250"
      title="금형 도면파일 등록"
    >
      <dx-data-grid ref='refPressDieFileGrid'
        :data-source='pressDieFileList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :row-alternation-enabled="true"
        key-expr="seqId"
        :focused-row-enabled="false"
        :auto-navigate-to-focused-row="false"
        @row-removed='onFileRowRemoved'
        @toolbar-preparing='onToolbarPreparingRegPressDieFile'
        :height="180"
      >
        <DxEditing
        :allow-deleting="true"
        :use-icons="true"
        mode="row"
        />
        <DxColumn
          :allowEditing='false'
          caption="파일명"
          data-field="파일명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="생성일자"
          data-field="createtime"
          format='yyyy-MM-dd HH:mm'
          dataType="date"
        >
        </DxColumn>
        <DxColumn
          width="60"
          :buttons="fileEditButtons"
          type="buttons"
        />
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </DxPopupGen>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
// 추가
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import ProductionGridComponent from '../../share/component/ProductionGridComponent'
import CompanyGridComponent from '../../share/component/CompanyGridComponent'
import axios from 'axios'
import HttpService from '../../share/service/HttpService'
// import underscore from 'vue-underscore'
export default {
  name: 'pressDieInfo',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_생산_연구,
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '금형관리'
        }
      ],
      // emtpy 추가
      pressDieInfoList: null,
      focusedRowKey: null,
      editButtons: ['edit', 'delete', {
        hint: '도면 삽입',
        icon: 'upload',
        visible: 'true',
        onClick: this.popupPressDieOn
        // onClick: (args) => {
        //   this.popupPressDieFileList = true
        // }
      }
      ],
      fileEditButtons: ['delete',
        {
          hint: '이미지 다운로드',
          icon: 'download',
          visible: 'true',
          onClick: this.onFileDown
        }
      ],
      isIdEdit: false,
      companyInfoList발주사: null,
      companyInfoList협력사: null,
      selectedCompanyCode: null,
      selectedProCompanyCode: null,
      selectedProductionCode: null,
      selectedRow: null,
      popupPressDieFileList: false,
      pressDieFileList: null,
      customerLookup: this.$store.getters.getCustomerInfo,
      partnerLookup: this.$store.getters.getPartnersInfo
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxForm,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxPopup,
    DxPosition,
    DxRequiredRule,
    DxItem,
    DxPopupGen,
    ProductionGridComponent,
    CompanyGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.pressDieTypeLookup = this.$_.sortBy(this.$store.getters.getBaseDataByType(ConstDef.금형사급))
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.refreshPressDieInfo()
    this.refreshProduction()
    this.refreshCompany()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onEditorPreparing (e) {
      if (e.dataField === '생산품번' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
      if (e.dataField === '공정순서' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    refreshPressDieInfo () {
      this.$_sp.runNoEncodeFindProc('spFindAllPressDie', {})
      // this.$_sp.runNoEncodeFindSqlProc('금형정보', null)
        .then((data) => {
          this.pressDieInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onSelectionChanged (e) {
      this.selectedRow = e.row.data
    },
    onRowRemoved (row) {
      const 도면 = this.$_sp.runNoEncodeFindSqlProc('금형도면', { 금형관리번호: this.selectedRow.seqId })
      const 사진 = this.$_sp.runNoEncodeFindSqlProc('금형정보', { seqId: this.selectedRow.seqId })
      axios.all([도면, 사진])
        .then(axios.spread((...reponse) => {
          this.pressDieFileList = this.$_sp.MakeModel(reponse[0])
          let 사진 = this.$_sp.MakeModel(reponse[1])
          let arr = []
          for (var value of this.pressDieFileList) {
            arr.push(value.파일경로)
          }
          arr.push(사진[0].파일경로)
          console.log(arr)
          this.deleteFile(row, '금형정보', arr)
          this.selectedRow = null
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      // row.data.생산품번 = this.selectedProductionCode
      row.data.제품생산처 = this.selectedProCompanyCode
      row.data.고객사 = this.selectedCompanyCode
      row.data.updateid = row.data.createid = this.userInfo.userName
      if (row.data.입고일자 !== null && (typeof row.data.입고일자) === 'object') {
        row.data.입고일자 = row.data.입고일자.getTime()
      }
      if (row.data.반납일자 !== null && (typeof row.data.반납일자) === 'object') {
        row.data.반납일자 = row.data.반납일자.getTime()
      }
      this.$_sp.runInsertAndFindSqlProc('금형정보', ['생산품번', '공정순서'], ['seqId', '품명', '제품생산처명', '고객사명', '파일명'], row.data)
        .then((data) => {
          row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          console.log(row.data.seqId)
          this.$snotify.info('추가되었습니다.')
          this.$refs.refPressDieGrid.instance.refresh()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
      console.log(this.pressDieInfoList)
      const index = this.$_.findIndex(this.pressDieInfoList, { 생산품번: row.data.생산품번, 공정순서: row.data.공정순서 })
      console.log(index)
      if (index >= 0) {
        this.$snotify.info('공정순서가 중복 되었습니다.')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      if (this.selectedProCompanyCode !== null && this.selectedProCompanyCode !== '') {
        row.data.제품생산처 = this.selectedProCompanyCode
      }
      if (this.selectedCompanyCode !== null && this.selectedCompanyCode !== '') {
        row.data.고객사 = this.selectedCompanyCode
      }
      if (row.data.입고일자 !== null && (typeof row.data.입고일자) === 'object') {
        row.data.입고일자 = row.data.입고일자.getTime()
      }
      if (row.data.반납일자 !== null && (typeof row.data.반납일자) === 'object') {
        row.data.반납일자 = row.data.반납일자.getTime()
      }
      console.log(row.data)
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('금형정보', ['생산품번', '공정순서'], ['seqId', '품명', '제품생산처명', '고객사명', '파일명', '파일경로'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onUpdating (row) {

    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
    },
    refreshProduction () {
      this.$_sp.runNoEncodeFindProc('spFindAllProductByType', { 품목유형: ConstDef.다공정품 })
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setProductionCode (code) {
      this.selectedProductionCode = code
      console.log(this.selectedProductionCode)
    },
    setCompnayCode (code) {
      // console.log(code)
      this.selectedCompanyCode = code
    },
    setProCompnayCode (code) {
      // console.log(code)
      this.selectedProCompanyCode = code
    },
    refreshCompany () {
      const 발주사 = this.$_sp.runNoEncodeFindSqlProc('거래처정보', { 거래처구분코드: ConstDef.COMPANY_발주사 })
      const 협력사 = this.$_sp.runNoEncodeFindSqlProc('거래처정보', { 거래처구분코드: ConstDef.COMPANY_협력사 })
      axios.all([발주사, 협력사])
        .then(axios.spread((...reponse) => {
          this.companyInfoList발주사 = this.$_sp.MakeModel(reponse[0])
          this.companyInfoList협력사 = this.$_sp.MakeModel(reponse[1])
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onFileSelect (type) {
      console.log(type)
      if (type === 'image') {
        if (this.selectedRow === null) {
          this.$snotify.error('해당 행 을 선택해주세요.')
          return false
        }
      // this.selectedProdCode = e.row.data.생산품번
      // this.selectedProcOrderCode = e.row.data.공정순서
      }
      this.$Q('#product-photo-input').click()
    },
    onFileChange: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let fileType = $event.target.name
      const form = new FormData()
      const file = $event.target.files[0]
      form.append('file', file)
      form.append('생산품번', this.selectedRow.생산품번)
      form.append('공정순서', this.selectedRow.공정순서)
      form.append('fileType', fileType)
      if (fileType === 'file') {
        let ver = 1
        if (this.pressDieFileList.length > 0) {
          let fileName = this.$_.max(this.pressDieFileList, function (stooge) { return stooge.createtime })
          if (fileName !== null) {
            ver = parseInt((fileName.파일명.split('-ver')[1]).replace('/[^0-9]/g', ''))
            ver = ver + 1
          }
        }
        form.append('fileCnt', ver)
      }
      this.$Q('#product-photo-input').val('')
      this.$Q('#die-drawing-input').val('')
      let url = '/pressDieUpload'
      HttpService.upload(form, url)
        .then((data) => {
          this.pressDieInsertOrUpdate(fileType, data.PATH, data.fileName)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR || error.response.status === ConstDef.NOT_ACCEPTABLE) {
            this.$snotify.error(error.response.data.message, { timeout: 0 })
          }
        })
    },
    onImgDown () {
      if (this.selectedRow !== null) {
        if (this.selectedRow.파일경로 === null) {
          this.$snotify.error('사진이 없습니다.')
          return false
        }
        window.open(ConstDef.apiUrl + `/imgLoadAll?file=` + this.selectedRow.파일경로)
      } else {
        this.$snotify.error('해당 행 을 선택해주세요.')
      }
    },
    onFileDown (e) {
      window.open(ConstDef.apiUrl + `/imgLoadAll?file=` + e.row.data.파일경로)
    },
    onToolbarPreparingRegPressDieFile (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '파일추가',
            icon: 'add',
            text: '파일추가',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#die-drawing-input').click()
            }
          }
        }
      )
    },
    onToolbarPreparingRegPressDieImage (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '제품사진 추가',
            icon: 'add',
            text: '제품사진 추가',
            type: 'default',
            disabled: (this.userInfo.permission & this.crudAllow) === 0,
            focusStateEnabled: true,
            onClick: (args) => {
              this.onFileSelect('image')
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '제품사진 다운로드',
            icon: 'download',
            text: '제품사진 다운로드',
            type: 'success',
            onClick: (args) => {
              this.onImgDown()
            }
          }
        }
      )
    },
    popupPressDieOn (e) {
      this.isLoading = true
      this.refreshPressDieFileList(e.row.data)
      this.selectedRow = e.row.data
      this.popupPressDieFileList = true
    },
    pressDieInsertOrUpdate (fileType, path, fName) {
      if (fileType === 'image') {
        const param = [
          { 생산품번: this.selectedRow.생산품번,
            파일경로: path }
        ]
        this.$_sp.runUpdateSqlProc('금형정보', ['생산품번'], null, param)
          .then((data) => {
            const where = this.$_.where(this.pressDieInfoList, { 생산품번: this.selectedRow.생산품번 })
            for (let i = 0; i < where.length; i++) {
              where[i].파일경로 = path
            }
            this.$refs.refPressDieGrid.instance.refresh()
            this.$snotify.info('저장 되었습니다.')
          })
          .catch(error => {
            this.isLoading = false
            if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              console.log(error)
            }
          })
      } else {
        let temp = {
          금형관리번호: this.selectedRow.seqId,
          파일경로: path,
          파일명: fName,
          createid: this.userInfo.userId,
          updateid: this.userInfo.userId
        }
        this.$_sp.runUpdateProc('spSavePressDieFile', [temp])
          .then((data) => {
            this.$snotify.info('저장 되었습니다.')
            this.refreshPressDieFileList(this.selectedRow)
          })
          .catch(error => {
            this.isLoading = false
            if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              console.log(error)
            }
          })
      }
    },
    refreshPressDieFileList (data) {
      console.log(data.seqId)
      this.$_sp.runNoEncodeFindSqlProc('금형도면', { 금형관리번호: data.seqId })
        .then((data) => {
          this.pressDieFileList = this.$_sp.MakeModel(data)
          console.log(this.pressDieFileList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onFileRowRemoved (row) {
      console.log(row.data)
      this.$_sp.runDeleteSqlProc('금형도면', [{ seqId: row.data.seqId }])
      this.deleteFile(row, '금형도면', row.data.파일경로)
      // this.selectedRow = null
    },
    deleteFile (row, deleteTarget, pathFileName) {
      let jsonData = {}
      if (!Array.isArray(pathFileName)) {
        jsonData = { pathFileName: [ pathFileName ] }
      } else {
        jsonData = { pathFileName: pathFileName }
      }
      const form = new FormData()
      form.append('jsonData', JSON.stringify(jsonData))
      let array = []
      array.push(HttpService.upload(form, '/deleteFile'))
      if (deleteTarget === '금형정보') {
        array.push(this.$_sp.runDeleteProc('spDeleteAllPressDieInfoByKey', [{ seqId: row.data.seqId }]))
      } else {
        array.push(this.$_sp.runDeleteSqlProc('금형도면', [{ seqId: row.data.seqId, 파일경로: row.data.파일경로 }]))
      }
      axios.all(array)
        .then(axios.spread((...reponse) => {
          this.$snotify.info('삭제되었습니다.')
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
